// <costiera-cart-addon>: one-tap add of an add-on product from the cart drawer.
// Loaded once from snippets/cart-drawer.liquid; Horizon morphs the drawer markup, so listen on the element itself
// and read the button / variant select at event time.
class CostieraCartAddon extends HTMLElement {
  connectedCallback() {
    if (this.wired) return;
    this.wired = true;
    this.addEventListener('click', (event) => {
      const button = event.target.closest('.costiera-addon__add');
      if (button) this.add(button);
    });
    this.addEventListener('change', (event) => {
      if (!event.target.matches('[data-variant]')) return;
      const option = event.target.selectedOptions[0];
      const price = this.querySelector('[data-price]');
      // Our own Liquid money markup (price + optional <s>compare-at</s>).
      if (option && price) price.innerHTML = option.dataset.priceHtml;
    });
  }

  async add(button) {
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    const variantId = Number(this.querySelector('[data-variant]')?.value || this.dataset.variantId);
    const offer = await import(this.dataset.offerModule);
    await offer.addLinesToCart([{ id: variantId, quantity: 1 }], this);
    button.removeAttribute('aria-busy');
  }
}

if (!customElements.get('costiera-cart-addon')) customElements.define('costiera-cart-addon', CostieraCartAddon);
